export function getToc(body: HTMLElement): {
  toc: CommentBodyTocEntry[];
  hasHeadingError: boolean;
} {
  const tocData: CommentBodyTocEntry[] = [];
  let firstHeadingOrdinal = 0;
  let numberOfHeadings = 0;
  let numberOfEligibleHeadings = 0;
  let hasFlowError = false;

  body
    .querySelectorAll("h1, h2, h3, h4, h5, h6")
    .forEach((heading: Element, index: number) => {
      numberOfHeadings++;
      const humanIndex = index + 1;
      const level = parseInt(heading.nodeName.charAt(1));
      const id = `title-${humanIndex}`;
      const innerHTML = heading.innerHTML;

      if (index === 0 && level !== 1) {
        hasFlowError = true;
      }

      if ([1, 2].includes(level)) {
        numberOfEligibleHeadings++;
      }

      if (level === 1) {
        firstHeadingOrdinal++;
        tocData.push({ level, innerHTML, href: `#${id}`, subLevel: [] });
      }
      if (level === 2 && !!tocData.length) {
        const last = tocData[tocData.length - 1];
        if (last) {
          if (last.level !== 1) {
            // A heading level was skipped.
            hasFlowError = true;
          }

          last.subLevel.push({
            level,
            innerHTML,
            href: `#${id}`,
            subLevel: [],
          });
        }
      }
      heading.id = id;
    });

  const displayToc: boolean = numberOfEligibleHeadings > 2;
  const hasHeadingError: boolean =
    (numberOfHeadings > 0 && firstHeadingOrdinal === 0) || hasFlowError;

  return {
    toc: displayToc ? tocData : [],
    hasHeadingError,
  };
}

export interface CommentBodyTocEntry {
  innerHTML: string;
  level: number;
  href: string;
  subLevel: CommentBodyTocEntry[];
}
